.error {
	color: var(--color-error-text);
	font-size: var(--text-caption);

	&:empty {
		display: none;
	}
}
